export const faqs = [
  {
    id: "f1",
    question: "看料社的内容主要整理什么？",
    answer:
      "看料社专注把网络上分散的热门爆料、合集与系列内容重新归档，做成结构清晰的专题。每个专题包含事件背景、关键节点和完整时间线，方便你一次看完来龙去脉。",
  },
  {
    id: "f2",
    question: "资源库里的内容多久更新一次？",
    answer:
      "资源库每日更新，热门专题会在事件出现新进展时补充内容，并在专题页标注最近更新时间。你可以通过资源库页面的「最近更新」排序快速找到新内容。",
  },
  {
    id: "f3",
    question: "为什么有的专题里文章数量不固定？",
    answer:
      "专题的文章数量取决于事件本身的复杂度。我们不会为了凑数而拆分内容，只收录具有信息价值的整理，因此不同专题的篇数天然不同。",
  },
  {
    id: "f4",
    question: "可以在手机上看吗？",
    answer:
      "可以。看料社采用响应式设计，在电脑、平板和手机上都能正常浏览，导航菜单在手机端会自动收起为菜单按钮，点开即可切换页面。",
  },
  {
    id: "f5",
    question: "内容可以转载或引用吗？",
    answer:
      "欢迎在注明来源的前提下引用。如需整篇转载，请通过页面底部的联系邮箱与我们沟通，我们会尽快回复授权范围。",
  },
  {
    id: "f6",
    question: "发现内容有误可以反馈吗？",
    answer:
      "当然可以。我们非常重视信息的准确性，如果你发现时间线、事实描述或来源标注存在问题，欢迎通过联系邮箱反馈，核实后我们会及时修订。",
  },
];